//#region components/skeleton/skeleton_constants.js
var e = 3e6, t = {
	circle: "d-bar-circle",
	square: "d-bar2"
}, n = ["body", "heading"], r = {
	sm: "24px",
	md: "32px",
	lg: "48px"
}, i = {
	sm: "d-h16",
	md: "d-h24",
	lg: "d-h32"
}, a = {
	SKELETON_RIPPLE_DURATION: e,
	SKELETON_SHAPES: t,
	SKELETON_TEXT_TYPES: n,
	SKELETON_HEADING_HEIGHTS: i
};
//#endregion
export { i as SKELETON_HEADING_HEIGHTS, e as SKELETON_RIPPLE_DURATION, t as SKELETON_SHAPES, r as SKELETON_SHAPE_SIZES, n as SKELETON_TEXT_TYPES, a as default };

//# sourceMappingURL=skeleton-constants.js.map